import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Editor as H3Editor } from "../H1Block/Editor";
import { H3 } from "./H3Block";
import { defaultData } from "./H3BlockDefaultData";
import { meta } from "./H3BlockMetaData";

export const H3Block: BlockExport = {
  type: "component",
  Block: H3,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  Editor: H3Editor,
  defaultData,
  meta,
};
